import ComputeCreateEpic from '../components/ComputeCreateContainer/ComputeCreateContainer.epic';
export default ComputeCreateEpic;

//# sourceMappingURL=ComputeCreateEpic.js.map
